module.exports = __webpack_public_path__ + "@/assets/img/trend-down.66736139.svg";